import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

// KEEP OLD PROJECT IMAGES (UNCHANGED)
import BinanceSmartChain from "../../images/serviceSection/Crypto & Token Services/Binance Smart Chain development.png";
import CryptoDevelopment from "../../images/serviceSection/Crypto & Token Services/Crypto Development.png";
import CryptoMarketing from "../../images/serviceSection/Crypto & Token Services/Crypto Marketing.png";
import ICODevelopment from "../../images/serviceSection/Crypto & Token Services/ICO Development.png";
import IGOPlatform from "../../images/serviceSection/Crypto & Token Services/IGO Platform.png";
import ILOPlatform from "../../images/serviceSection/Crypto & Token Services/ILO Platform.png";
import TokenDevelopment from "../../images/serviceSection/Crypto & Token Services/Token Development.png";
import TokenLaunch from "../../images/serviceSection/Crypto & Token Services/Token Launch.png";


// SAME ARROW ICON (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔑 MEGAMENU-4 → PAGE DATA
const megaProjects = [
  {
    title: "Crypto Development",
    content:
      "End-to-end cryptocurrency development including exchanges, wallets, smart contracts, and secure blockchain infrastructure.",
    link: "/crypto-exchange-service",
    images: [CryptoDevelopment, CryptoDevelopment, CryptoDevelopment, CryptoDevelopment],
    reverse: false,
  },
  {
    title: "Token Launch",
    content:
      "Complete token launch solutions covering strategy, smart contracts, audits, and post-launch support.",
    link: "/token-launch",
    images: [TokenLaunch, TokenLaunch, TokenLaunch, TokenLaunch],
    reverse: true,
  },
  {
    title: "BSC Development",
    content:
      "Binance Smart Chain development services for fast, low-cost, and scalable decentralized applications.",
    link: "/bsc-development",
    images: [BinanceSmartChain, BinanceSmartChain, BinanceSmartChain, BinanceSmartChain],
    reverse: false,
  },
  {
    title: "IGO Platform",
    content:
      "Initial Game Offering platforms to launch blockchain-based gaming projects with secure fundraising models.",
    link: "/igo",
    images: [IGOPlatform, IGOPlatform, IGOPlatform, IGOPlatform],
    reverse: true,
  },
  {
    title: "ICO Development",
    content:
      "ICO development services including token creation, compliance consulting, and investor-ready infrastructure.",
    link: "/ico",
    images: [ICODevelopment, ICODevelopment, ICODevelopment, ICODevelopment],
    reverse: false,
  },
  {
    title: "Token Development",
    content:
      "Custom token development across ERC20, BEP20, and multi-chain standards with full lifecycle support.",
    link: "/token-development",
    images: [TokenDevelopment, TokenDevelopment, TokenDevelopment, TokenDevelopment],
    reverse: true,
  },
  {
    title: "ILO Platform",
    content:
      "Initial Liquidity Offering platforms designed to ensure early liquidity and sustainable token ecosystems.",
    link: "/ilo",
    images: [ILOPlatform, ILOPlatform, ILOPlatform, ILOPlatform],
    reverse: false,
  },
  {
    title: "Crypto Marketing",
    content:
      "Data-driven crypto marketing services including community growth, influencer outreach, and exchange listings.",
    link: "/cryptocurrency-marketing-services",
    images: [CryptoMarketing, CryptoMarketing, CryptoMarketing, CryptoMarketing],
    reverse: true,
  },
];

const CryptoTokenServicesPage: React.FC = () => {
  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle="Crypto & Token Services"
              pagesub="Development, Launch & Marketing"
            />

            <section className="service pos-rel">
              <div className="container mxw-1650">
                <div className="xb-project-wrap xb-project-wrap_2">

                  {megaProjects.map((item, index) => (
                    <div className="xb-project-item" key={index}>

                      {!item.reverse ? (
                        <>
                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>

                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>

                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                    </div>
                  ))}

                </div>
              </div>
            </section>

          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CryptoTokenServicesPage;
